module.exports = __webpack_public_path__ + "static/media/champagne-glas.d0bdecdf.png";